import { TableCell, styled } from "@mui/material";

export const StyledTableCell = styled(TableCell)`
  padding: 8px 1em;
`;
